// AMBLEHOME — custom storefront JS (vanilla, no framework, no theme JS dependency)
(function(){
  'use strict';

  /* ---------------- Currency-aware money formatting ----------------
     Shopify injects window.Shopify.currency = { active, rate } when a
     shop has multi-currency (Markets local currencies) enabled and the
     visitor is being served a converted currency. `rate` converts from
     the shop's base currency to the visitor's active currency. We must
     use this instead of hardcoding a currency symbol, otherwise prices
     shown after JS runs would be wrong (e.g. showing "$" in front of a
     raw TRY amount for a US visitor). Falls back to shop.money_format-
     compatible plain formatting if Shopify.currency isn't present. */
  function activeCurrency(){
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (window.shopCurrency) || 'USD';
  }
  function currencyRate(){
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && !isNaN(r) ? r : 1;
  }
  function formatMoney(cents){
    var amount = (cents/100) * currencyRate();
    try {
      return new Intl.NumberFormat(undefined, { style:'currency', currency: activeCurrency(), currencyDisplay: 'narrowSymbol' }).format(amount);
    } catch(e){
      return activeCurrency() + ' ' + amount.toFixed(2);
    }
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(){
    var items = document.querySelectorAll('.amara-reveal');
    if(!items.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },{threshold:0.15});
    items.forEach(function(el){ io.observe(el); });
  }

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav(){
    var burger = document.querySelector('[data-amara-burger]');
    var nav = document.querySelector('[data-amara-mobile-nav]');
    var close = document.querySelector('[data-amara-mobile-close]');
    if(!burger || !nav) return;
    burger.addEventListener('click', function(){ nav.classList.add('is-open'); });
    if(close) close.addEventListener('click', function(){ nav.classList.remove('is-open'); });
    nav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ nav.classList.remove('is-open'); });
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer, cartOverlay;

  function renderCart(cart){
    var itemsEl = document.querySelector('[data-amara-cart-items]');
    var subtotalEl = document.querySelector('[data-amara-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-amara-cart-count]');
    if(!itemsEl) return;

    countEls.forEach(function(el){ el.textContent = cart.item_count; });

    if(!cart.items.length){
      itemsEl.innerHTML = '<div class="amara-cart-empty">Your cart is empty.</div>';
      if(subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }

    var html = '';
    cart.items.forEach(function(item){
      var opts = (item.options_with_values || []).map(function(o){ return o.name + ': ' + o.value; }).join(' / ');
      html += '' +
        '<div class="amara-cart-line" data-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div style="flex:1">' +
            '<div class="amara-cart-line__title">' + item.product_title + '</div>' +
            (opts ? '<div class="amara-cart-line__opts">' + opts + '</div>' : '') +
            '<div class="amara-cart-line__opts">' + formatMoney(item.final_price) + '</div>' +
            '<div class="amara-cart-line__qty">' +
              '<button type="button" data-cart-decrease>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cart-increase>&plus;</button>' +
            '</div>' +
            '<div class="amara-cart-line__remove" data-cart-remove>Remove</div>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart);
  }

  function changeLine(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:quantity})
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  function openCart(){
    if(cartDrawer){ cartDrawer.classList.add('is-open'); cartOverlay.classList.add('is-open'); document.body.style.overflow='hidden'; }
  }
  function closeCart(){
    if(cartDrawer){ cartDrawer.classList.remove('is-open'); cartOverlay.classList.remove('is-open'); document.body.style.overflow=''; }
  }

  function showToast(msg){
    var toast = document.querySelector('[data-amara-toast]');
    if(!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function(){ toast.classList.remove('is-visible'); }, 2600);
  }

  function initCart(){
    cartDrawer = document.querySelector('[data-amara-cart-drawer]');
    cartOverlay = document.querySelector('[data-amara-cart-overlay]');
    if(!cartDrawer) return;

    document.querySelectorAll('[data-amara-cart-open]').forEach(function(btn){
      btn.addEventListener('click', function(e){ e.preventDefault(); fetchCart(); openCart(); });
    });
    var closeBtn = document.querySelector('[data-amara-cart-close]');
    if(closeBtn) closeBtn.addEventListener('click', closeCart);
    if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

    document.querySelector('[data-amara-cart-items]').addEventListener('click', function(e){
      var line = e.target.closest('.amara-cart-line');
      if(!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.amara-cart-line__qty span');
      var qty = parseInt(qtyEl.textContent, 10);
      if(e.target.hasAttribute('data-cart-increase')){ changeLine(key, qty+1); }
      if(e.target.hasAttribute('data-cart-decrease')){ changeLine(key, Math.max(0, qty-1)); }
      if(e.target.hasAttribute('data-cart-remove')){ changeLine(key, 0); }
    });

    // intercept every add-to-cart form on the site (PDP + quick add)
    document.addEventListener('submit', function(e){
      var form = e.target.closest('form[data-amara-add-to-cart]');
      if(!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var original = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body: formData })
        .then(function(r){ return r.json(); })
        .then(function(){
          showToast('Added to cart');
          fetchCart();
          openCart();
        })
        .catch(function(){ showToast('Something went wrong'); })
        .finally(function(){ if(btn){ btn.disabled=false; btn.textContent = original; } });
    });

    fetchCart();
  }

  /* ---------------- PDP: gallery + variant picker ---------------- */
  function initPDP(){
    var pdp = document.querySelector('[data-amara-pdp]');
    if(!pdp) return;

    var mainImg = pdp.querySelector('[data-amara-pdp-main-img]');
    pdp.querySelectorAll('[data-amara-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        pdp.querySelectorAll('[data-amara-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if(mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.src;
      });
    });

    var variantData = JSON.parse(pdp.getAttribute('data-variants') || '[]');
    var selected = {};
    pdp.querySelectorAll('[data-amara-swatch].is-selected').forEach(function(sw){
      selected[sw.getAttribute('data-index')] = sw.getAttribute('data-value');
    });
    if(!Object.keys(selected).length && variantData.length){
      var fallback = variantData.find(function(v){ return v.available; }) || variantData[0];
      fallback.options.forEach(function(val, i){ selected[i] = val; });
    }
    var priceEl = pdp.querySelector('[data-amara-price]');
    var compareEl = pdp.querySelector('[data-amara-compare-price]');
    var variantIdInput = pdp.querySelector('[data-amara-variant-id]');
    var addBtn = pdp.querySelector('[data-amara-add-btn]');

    function currentVariant(){
      return variantData.find(function(v){
        return v.options.every(function(val, i){ return selected[i] === val; });
      });
    }

    // Only one variant total (no real options to switch between) — leave the
    // server-rendered, correctly-localized {{ price | money }} markup alone.
    var singleVariant = variantData.length <= 1;

    function updateUI(){
      var v = currentVariant();
      pdp.querySelectorAll('[data-amara-swatch]').forEach(function(sw){
        var idx = parseInt(sw.getAttribute('data-index'), 10);
        var val = sw.getAttribute('data-value');
        var testSel = Object.assign({}, selected); testSel[idx] = val;
        var exists = variantData.some(function(vv){
          return vv.available && vv.options.every(function(vv2, i){ return i === idx ? vv2 === val : (testSel[i] === undefined || testSel[i] === vv2); });
        });
        sw.classList.toggle('is-selected', selected[idx] === val);
        sw.toggleAttribute('disabled', !exists);
      });
      if(v){
        if(priceEl && !singleVariant) priceEl.textContent = formatMoney(v.price);
        if(compareEl && !singleVariant){
          if(v.compare_at_price && v.compare_at_price > v.price){
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.style.display = '';
          } else { compareEl.style.display = 'none'; }
        }
        if(variantIdInput) variantIdInput.value = v.id;
        if(addBtn){
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
        }
      } else if(addBtn){
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-soldout');
      }
    }

    pdp.querySelectorAll('[data-amara-swatch]').forEach(function(sw){
      sw.addEventListener('click', function(){
        if(sw.hasAttribute('disabled')) return;
        var idx = sw.getAttribute('data-index');
        var val = sw.getAttribute('data-value');
        selected[idx] = val;
        pdp.querySelectorAll('[data-index="'+idx+'"]').forEach(function(s){ s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        updateUI();
      });
    });

    var qtyInput = pdp.querySelector('[data-amara-qty-input]');
    var qtyMinus = pdp.querySelector('[data-amara-qty-minus]');
    var qtyPlus = pdp.querySelector('[data-amara-qty-plus]');
    if(qtyMinus) qtyMinus.addEventListener('click', function(){
      qtyInput.value = Math.max(1, parseInt(qtyInput.value||1,10) - 1);
    });
    if(qtyPlus) qtyPlus.addEventListener('click', function(){
      qtyInput.value = parseInt(qtyInput.value||1,10) + 1;
    });

    pdp.querySelectorAll('[data-amara-accordion-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        btn.closest('.amara-pdp__accordion-item').classList.toggle('is-open');
      });
    });

    updateUI();
  }

  document.addEventListener('DOMContentLoaded', function(){
    initReveal();
    initMobileNav();
    initCart();
    initPDP();
  });
})();
